define([], function () {
    function config($stateProvider) {
        $stateProvider
            .state('app.googleads', {
                abstract: true,
                url: '/google-ads',
                templateUrl: './app/modules/googleads/googleads.html',
                resolve: {
                    notVerifiedRedirect: ['UserService', 'AuthService', '$state', function (UserService, AuthService, $state) {
                        return UserService.limits(true)
                            .then(function (res) {
                                var user = AuthService.getSessionUser();
                                if (res && res.data && !res.data.isActive && user && user.email) {
                                    $state.go('access.email-verification', {
                                        token: btoa(user.email)
                                    });
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                    }]
                }
            })
            .state('app.googleads.planner', {
                url: '',
                controller: 'GoogleAdsPlannerCtrl',
                templateUrl: './app/modules/googleads/planner/planner.html'
            });
    }

    config.$inject = ['$stateProvider'];
    return config;
});
